import Url from '@music/mobile-url';
import {makeActionCreator, makeActionType, getActionType} from '../util/redux';
import Request from '../util/fetch';
import {Toast} from '../component/message';
export const InsType = 'ins';

const mockUserId = Url.CurrentParams.mockUserId || '';

//创建Types
makeActionType(InsType, ['qrrequest', 'qycomplete', 'editstep', 'editprogress']);
export const insClear = makeActionCreator(getActionType(InsType, 'clear'));
export const insSuccess = makeActionCreator(getActionType(InsType, 'success'));
export const insFail = makeActionCreator(getActionType(InsType, 'fail'));
export const insQueryComplete = makeActionCreator(getActionType(InsType, 'qycomplete'));
export const insChangeStep = makeActionCreator(getActionType(InsType, 'editstep'));
export const insChangeProgress = makeActionCreator(getActionType(InsType, 'editprogress'));


//获取支持导入视频的网站名称
export const insRequest = (data) => (dispatch) => {
    dispatch({
        type : getActionType(InsType, 'request'),
        payload : data
    });
    data = data || {};
    return Request.fetch({
        url : "api/cloudvideo/video/grab/info",
        method : "get"
    })
    .then(function(data){
        dispatch(insSuccess(data));
    })
    .catch(error => {
        let rerr = Request.resolveError(error);
        dispatch(insFail(rerr))
    });
}
//查询链接是否正确
export const insQueryRequest = (data) => (dispatch) => {
    dispatch({
        type : getActionType(InsType, 'qrrequest'),
        payload : data
    });
    return Request.fetch({
        url : "api/cloudvideo/video/url/check",
        data : data
    })
    .then(function(res){
        let resData = res.data;
        if(resData){
            dispatch(insQueryComplete({
                success : true
            }));
        }
        else{
            Toast({
                type : 'error',
                text : '请输入正确的链接地址'
            })
            dispatch(insQueryComplete({}))
        }
    })
    .catch(error => {
        let rerr = Request.resolveError(error);
        Toast({
            type : 'error',
            text : rerr.msg
        })
        dispatch(insQueryComplete(rerr))
    });
}




// WEBPACK FOOTER //
// ./client/action/ins.js